module.exports = __webpack_public_path__ + "img/library.346534fa.png";